var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('conditions',{attrs:{"items":_vm.conditions,"loading":_vm.loading,"can-edit":_vm.$props.canEdit},on:{"push-to-create-router":_vm.pushToCreateRouter,"push-to-edit-router":_vm.pushToEditRouter,"save-condition":_vm.saveCondition,"delete-condition":_vm.deleteCondition}})
}
var staticRenderFns = []

export { render, staticRenderFns }